import { render, staticRenderFns } from "./uploadManagerVC.vue?vue&type=template&id=5af17a9d&"
import script from "./uploadManagerVC.vue?vue&type=script&lang=js&"
export * from "./uploadManagerVC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports